import { Grid2 } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const BasicTenderInfo = ({ tender }) => {
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };

  return tender ? (
    <div className="dashboard-container">
      <Grid2 container columnSpacing={2} rowSpacing={2}>
        <Grid2 size={{ xs: 4, md: 2.4 }}>
          <div style={{ position: "relative" }}>
            <div className="tender-title">Tender Name</div>
            <div className="tender-info">
              {storedUser.userRole[0] === "VENDOR" ? <div>
                {tender.title}
              </div> :
              <Link to={`/dashboard/tender/${tender.tenderId}`} style={{textDecoration: 'underline'}}>
                {tender.title}
              </Link>}
            </div>
          </div>
        </Grid2>
        <Grid2 size={{ xs: 4, md: 2.4 }}>
          <div style={{ position: "relative" }}>
            <div className="tender-title">Tender ID</div>
            <div className="tender-info">{tender.tenderId}</div>
          </div>
        </Grid2>
        <Grid2 size={{ xs: 4, md: 2.4 }}>
          <div style={{ position: "relative" }}>
            <div className="tender-title">Status</div>
            <div className="tender-info">{tender.status}</div>
          </div>
        </Grid2>
        <Grid2 size={{ xs: 4, md: 2.4 }}>
          <div style={{ position: "relative" }}>
            <div className="tender-title">Tender Publish Date</div>
            <div className="tender-info">
              {formatDate(tender.tenderPublishDate)}
            </div>
          </div>
        </Grid2>
        <Grid2 size={{ xs: 4, md: 2.4 }}>
          <div style={{ position: "relative" }}>
            <div className="tender-title">Bid Close Date</div>
            <div className="tender-info">
              {formatDateTime(tender.bidSubmissionEndDate)}
            </div>
          </div>
        </Grid2>
      </Grid2>
    </div>
  ) : null;
};

export default BasicTenderInfo;
